<app-loader *ngIf="showLoading"></app-loader>
<form>
    <div class="main-wrapper">
        <app-header > </app-header>
        <app-leftmenu ></app-leftmenu>
        <div class="page-wrapper">
            <div class="content container-fluid">
                <!-- Page Header -->
                <div class="page-header">
                    <div class="row align-items-center">
                        <div class="col">
                            <h3 class="page-title">{{PageTitle}}</h3>
                            <ul class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <a routerLink="/Dashboard"> Dashboard</a>
                                </li>
                                <li class="breadcrumb-item active">{{PageTitle}}</li>
                            </ul>
                        </div>
                      <!--<div class="col-auto float-right ml-auto">
                            <button mat-flat-button color="warn" (click)="filterFunc()">
                                <mat-icon aria-hidden="false">filter</mat-icon> Filter</button>
                        </div> -->  
                    </div>
                </div>
                <!-- /Page Header -->
                <div class="filter-box" *ngIf="filterDiv">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <mat-form-field class="example-full-width">
                                    <mat-select [(ngModel)]="FilterData.projectid" name="projectname" 
                                    [typeaheadDebounceInterval]="matSelectDuration" placeholder="Search by project name">
                                        <mat-option >-Select-</mat-option>
                                        <mat-option *ngFor="let project of projectList" [value]="project.selectionvalue">
                                          {{ project.selectionvalue }}
                                        </mat-option>
                                      </mat-select>
                                </mat-form-field>
                            </div>
                        </div>

                       
                        
                    </div>
                    <div class="submit-section">
                       
                        <button mat-flat-button color="primary" (click)="getReport()">
                            <mat-icon aria-hidden="false">search</mat-icon> Search
                        </button> 
                        <button mat-flat-button color="warn" (click)="cancel()">
                            <mat-icon aria-hidden="false">cancel</mat-icon> Cancel
                        </button>
                    </div>
                </div>
                <div class="tab-content">

                    <!-- Add Family -->
                    <div class="pro-overview tab-pane fade show active">
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                             
                            <table mat-table [dataSource]="InvoiceRecord" matSort class="mat-elevation-z8">
                               

                                <!--  Name Column -->
                                <ng-container matColumnDef="projectpin">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Project Pin </th>
                                    <td mat-cell *matCellDef="let InvoiceRecord ">
                                        <div class="block"> {{InvoiceRecord.projectpin}}</div>
                                        
                                    </td>
                                </ng-container>


                                 
                                 <ng-container matColumnDef="customername">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Customer Name </th>
                                    <td mat-cell *matCellDef="let InvoiceRecord ">
                                        <div class="block"> {{InvoiceRecord.customername}} </div>

                                    </td>
                                </ng-container>

                                <!--  Email Column -->
                                <ng-container matColumnDef="invoiceno">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Invoice No </th>
                                    <td mat-cell *matCellDef="let InvoiceRecord ">
                                        <div class="block"> {{InvoiceRecord.invoiceno}} </div>
                                    </td>
                                </ng-container>

                                <!--  address Column -->
                                <ng-container matColumnDef="invoicedate">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Invoice Date</th>
                                    <td mat-cell *matCellDef="let InvoiceRecord ">
                                        <div class="block" *ngIf="InvoiceRecord.invoicedate > 0"> {{InvoiceRecord.invoicedate| date:'dd-MM-yyyy'}} </div>
                                        <div class="block" *ngIf="InvoiceRecord.invoicedate == 0"> </div>

                                    </td>
                                </ng-container>

                              <!--  Email Column -->
                                <ng-container matColumnDef="totalamount">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Amount </th>
                                    <td mat-cell *matCellDef="let InvoiceRecord ">
                                        <div class="block"> {{InvoiceRecord.totalamount}} </div>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="ageingsince">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Ageing Since </th>
                                    <td mat-cell *matCellDef="let InvoiceRecord ">
                                        <div class="block"> {{InvoiceRecord.ageingsince}} </div>
                                    </td>
                                </ng-container>
                              
                                 <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            </table>
                            <mat-paginator [pageSize]="pageSizedisplay" [pageSizeOptions]="itemPerPage"
                                showFirstLastButtons>
                            </mat-paginator>
                        </div>
                    </div>
                </div>
                  
            </div>
        </div>
        </div>
    </div>
 </div>
</form>